<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="key-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="key-view">
                        <p>密钥复制成功，你的密钥为：</p>
                        <div class="key-pannel">
                            <div class="key-item" v-for="(item, index) in inviteCode" :key="index">
                                {{ item }}
                            </div>
                        </div>
                        <p>快去邀请玩家进行绑定吧！</p>
                    </div>

                    <div class="u-btn ok" @click="destroyElement()"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){
    .dialog-view{
        z-index: 100;
    }

    .key-modal{
        width: 620px;
        height: 440px;
        background-image: url(~@/assets/images/modal/bg-modal-rule.png);        
    }

    .title{
        width: 524px;
        height: 51px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/modal/title-key.png);  
    }

    .key-view{
        
        padding: 0 74px;
        font-size: 21px;
        color: #4b4846;

        p{
            margin-bottom: 20px;
            text-align: center;
        }

        .key-pannel{
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;

            .key-item{
                width: 59px;
                height: 133px;
                line-height: 133px;
                font-size: 36px;
                color: #c2393f;                
                text-align: center;
                margin-right: 5px;
                background-image: url(~@/assets/images/pc/join-item.png);                
            }
        }
    }


    .u-btn.ok{
        position: absolute;
        left: 50%;
        bottom: 25px;
        transform: translateX(-50%);               
        width: 207px;
        height: 55px;
        margin: 20px auto 0;
        background-image: url(~@/assets/images/modal/btn-ok.png);  
    }        

}


@media screen and (min-width: 1000px){
    @include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
    @include boxStyle( 1000 );
}   
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
            inviteCode : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    mounted (){

    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/KeyModal/Modal.vue